import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { ForumService } from 'src/app/services/forum/forum.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';

@Component({
  selector: "app-add-forum",
  templateUrl: "./add-forum.component.html",
  styleUrls: ["./add-forum.component.scss"],
})
export class AddForumComponent {
  public forumForm!: FormGroup;
  public departmentData: any[] = [];
  dropdownSettings: IDropdownSettings = {};
  public files: File[] = [];
  public imgURL: String = GlobalService.imageURL;
  public imagePath;
  public forumData: any;
  public isEditForum: boolean = false;
  listMaxHeight=500;
  constructor(
    private commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private forumService: ForumService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private cd: ChangeDetectorRef,
    private appService: AppService,

    public dialogRef: MatDialogRef<AddForumComponent>,
    private userManagementService: UserManagementService
  ) {}
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.forumForm = this.fb.group({
      tit: [
        "",
        Validators.compose([Validators.required, Validators.minLength(3)]),
      ],
      desc: [
        "",
        Validators.compose([Validators.required, Validators.minLength(3)]),
      ],
      d_i: ["", Validators.required],
    });
    this.departmentList();
    this.dropdownSettings = {
      idField: 'cd_i',
      textField: 'dep',
      // below setting will help to enable search filter in multi select dropdown
    };
    if (this.dialogData) {
      this.isEditForum = true;
      // this.getForumDetail();
      // this.forumForm.get('tit')?.setValue(this.dialogData.tit)
      // this.forumForm.get('desc')?.setValue(this.dialogData.desc)
    }
  }

  onSelect(event) {
    this.files = [];
    this.files.push(...event.addedFiles);
    var reader = new FileReader();
    reader.readAsDataURL(event.addedFiles[0]);
    reader.onload = (_event) => {
      this.imagePath = reader.result;
      if (this.forumData?.img) {
        this.forumData.img = "";
      }
    };
  }
  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(
      this.forumForm,
      controlName,
      validationType
    );
  }
  departmentList = (): void => {
    this.spinner.show();
    let obj={}
    this.userManagementService.departmentListing(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success.status == 200) {
          this.departmentData = success.data;
            if(this.isEditForum){
            this.getForumDetail()
          }
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  };
  getForumDetail() {
    this.spinner.show();
    this.forumService
      .detail(this.dialogData.id)
      .subscribe((success: Object) => {
        this.spinner.hide()
        this.forumData = success["data"];
        //  let data=response["data"]
        this.forumForm.get("tit")?.setValue(this.forumData.tit);
        this.forumForm.get("desc")?.setValue(this.forumData.desc);
        let newDepArr: any[] = [];
        for (
          let i = 0; i < JSON.parse(this.forumData.d_i).length; i++) {
          let obj = this.departmentData.find(
            (item) =>
              item.cd_i ==
              JSON.parse(this.forumData.d_i)[i]
          );
          if (obj) {
            newDepArr.push(obj);
          }
        }
        this.forumForm.patchValue({ d_i: newDepArr });
      });
  }
  onSubmit() {
    if (this.forumForm.invalid) {
      this.forumForm.markAllAsTouched();
    } else {
      let newDepId: any[] = [];
      let formData = new FormData();
      for (let i = 0; i < this.forumForm.value.d_i.length; i++) {
        newDepId.push(
          this.forumForm.value.d_i[i].cd_i
        );
      }
      let dataObj = this.forumForm.value;
      dataObj["d_i"] = newDepId;

      if (this.departmentData.length == newDepId.length) {
        dataObj["d_i"] = [];
        formData.append("d_i", "[]");
      } else {
        formData.append("d_i", JSON.stringify(newDepId));
      }
      this.spinner.show();
      formData.append("img", this.files[0]);
      formData.append("tit", this.forumForm.value.tit);
      formData.append("desc", this.forumForm.value.desc);
      if (!this.isEditForum) {
        this.forumService.create(formData).subscribe({
          next: (success: Object) => {
            this.spinner.hide();
            if (success["status"] == 200) {
              this.spinner.hide();
              this.appService.showToastMessage("success", success["msg"]);
              this.dialogRef.close({ data_added: true });
            }
          },
          error: (error: any) => {
            this.commonService.handleError(error);
          },
        });
      } else {
        formData.append("id", this.dialogData["id"]);
        this.forumService.edit(formData).subscribe({
          next: (response: Object) => {
            this.spinner.hide();
            if (response["status"] == 200) {
              this.spinner.hide();
              this.appService.showToastMessage("success", response["msg"]);
              this.dialogRef.close({ data_added: true });
            }
          },
          error: (error: any) => {
            this.commonService.handleError(error);
          },
        });
      }
    }
  }
  onCancel() {
    this.dialogRef.close();
  }
}
